// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KlEl","left":"styles_left__D4Xks","desktopActions":"styles_desktopActions__2IO31","title":"styles_title__2VxJ0"};